module.exports = __webpack_public_path__ + "static/media/sim-idle.d33e33a8.gif";